import { render, staticRenderFns } from "./InstructorEdit.vue?vue&type=template&id=3924d00c&"
import script from "./InstructorEdit.vue?vue&type=script&lang=js&"
export * from "./InstructorEdit.vue?vue&type=script&lang=js&"
import style0 from "./InstructorEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports